<template>
    <button
        class="navbar__back"
        :class="{'navbar__back--open': isVisible}"
        aria-label="Back to menu"
        data-testid="navbar-back"
        @click="$emit('click')"
    >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>
</template>

<script setup lang="ts">
    defineProps<{
        isVisible: boolean;
    }>();

    defineEmits<{
        click: [];
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .navbar__back {
        position: absolute;
        left: 0;
        bottom: 14px;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: var(--joy-color-neutral-50);
        opacity: 0;
        transform: translate3d(20px, 0, 0);
        transition:
            opacity calc(var(--navbar-transition-duration) * 0.4) var(--navbar-transition-easing),
            transform var(--navbar-transition-duration) var(--navbar-transition-easing);
        pointer-events: none;
        will-change: transform, opacity;
        backface-visibility: hidden;

        svg {
            display: block;
            position: relative;
            left: -4px;
        }

        &--open {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            pointer-events: auto;
            transition-delay: calc(var(--navbar-transition-duration) * 0.6), 0s;
        }
    }

    @include mq.screen_md(min) {
        .navbar__back {
            display: none;
        }
    }
</style>
